import { motion } from "framer-motion";
import { MessageSquare, Cog, Rocket, TrendingUp } from "lucide-react";

const STEPS = [
  {
    num: "01",
    icon: MessageSquare,
    title: "15-min Discovery",
    desc: "Tell us your business, lead sources, and what's breaking. We map your current flow.",
    color: "text-[#00F0FF]",
  },
  {
    num: "02",
    icon: Cog,
    title: "Custom Build",
    desc: "We design & wire your lead pipeline: forms, AI follow-ups, Sheets, dashboard. No templates.",
    color: "text-[#007AFF]",
  },
  {
    num: "03",
    icon: Rocket,
    title: "Launch in 7 Days",
    desc: "We plug it into your existing tools (WhatsApp, Gmail, Instagram, website) and go live.",
    color: "text-[#8B5CF6]",
  },
  {
    num: "04",
    icon: TrendingUp,
    title: "Scale & Optimize",
    desc: "We monitor, tune, and expand — adding new automations as your business grows.",
    color: "text-emerald-400",
  },
];

export default function HowItWorks() {
  return (
    <section id="process" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-[#00F0FF] mb-4" data-testid="process-kicker">How It Works</p>
          <h2 className="font-display text-4xl sm:text-5xl font-medium text-white leading-tight" data-testid="process-heading">
            From chaos to conversion in 4 steps.
          </h2>
          <p className="mt-5 text-white/60 text-lg max-w-2xl">
            No jargon, no long onboarding decks. Here's the exact path.
          </p>
        </div>

        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute left-0 right-0 top-10 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.num}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="glass-card p-6 relative group hover:-translate-y-1 transition-transform"
                data-testid={`process-step-${i}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <span className={`inline-flex items-center justify-center w-11 h-11 rounded-xl bg-white/[0.04] border border-white/10 ${s.color}`}>
                    <s.icon size={20} />
                  </span>
                  <span className={`font-display text-2xl font-semibold ${s.color} opacity-50`}>{s.num}</span>
                </div>
                <h3 className="font-display text-xl font-medium text-white mb-2">{s.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
